export const REVEAL_DATE = new Date("2026-02-16T18:27:00Z");

export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 3600;

export const COUNTDOWN_UPDATE_INTERVAL_MS = 1000;

export const TIME_FORMAT_PADDING = 2;
export const TIME_FORMAT_CHAR = "0";
